import { render, staticRenderFns } from "./WineDetails.vue?vue&type=template&id=72190402&"
import script from "./WineDetails.vue?vue&type=script&lang=js&"
export * from "./WineDetails.vue?vue&type=script&lang=js&"
import style0 from "./WineDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports